
import React, { useEffect, useState } from 'react';
import { cardBackground } from '../../../assets'
import { star } from '../../../assets';
import { star_greyed } from '../../../assets';
import { useSelector } from 'react-redux';
import { CircularProgress, Paper, Tooltip } from '@mui/material'
import Slider from "react-slick";
import { POSTINSTALLAPP, POSTINSTALLAPP2 } from '../../services/seller/endpoint';
import { toast } from 'react-toastify';
import InstallPopup from '../popup_modal/install_modal_popup';
import PropTypes from 'prop-types';  // Import PropTypes explicitly
import { install2 } from '../../../assets';
import '../../../sellers_module/components/app_details/slider.scss'
import { captureGAEvent, gaPanelConfig } from '../../shared/helper';
import { clearEvents } from '../../utils/changeHeaderColor';





const CardBanner = ({ appData }) => {
    const auth = useSelector((state: any) => state.auth);
    const authUrl = process.env.REACT_APP_REDIRECT_URL;
    const [isInstallLoading, setInstallLoading] = useState(false);

    const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL;
    const [isInstalled, setIsInstalled] = useState(false);
    const [errorInstallMessage, setInstallErrorMessage] = useState('');
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isTabletView, setIsTabletView] = useState<boolean>(false);


    useEffect(() => {
        const checkScreenSize = () => {
            setIsTabletView(window.innerWidth <= 1024); // Example: Consider width <= 1024 as tablet view
        };

        // Call checkScreenSize once to determine initial view
        checkScreenSize();

        // Add event listener to check screen size on resize
        window.addEventListener('resize', checkScreenSize);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);
    const ImageCarousel = ({ banners, height }) => {
        const settings = {

            dots: true,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 5000,
            autoplay: true,


        };

        // Perform null check for banners
        if (!banners || banners.length === 0) {
            // Return null or render an alternative component if banners is null or empty
            return null;
        }

        // Conditionally render the Slider component only if there is more than one banner
        if (banners.length > 1) {
            return (
                <Slider {...settings}>
                    {banners.map((banner, index) => (
                        <div key={index} style={{ borderRadius: '20px' }}>
                            <img
                                src={banner?.url} // Use optional chaining to handle null or undefined
                                alt={`Banner ${index + 1}`}
                                style={{
                                    minHeight: height,
                                    maxHeight: '100%',
                                    width: '100%',
                                    borderRadius: '20px',
                                    transition: 'opacity 0.5s ease-in-out',
                                }}
                            />
                        </div>
                    ))}
                </Slider>
            );
        } else {
            // Render something else or nothing if there's only one banner
            return null;
        }
    };
    ImageCarousel.propTypes = {
        banners: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                url: PropTypes.string,
            })
        ).isRequired,
        height: PropTypes.string.isRequired,
    };

    const handlePopupClose = () => {
        clearEvents()
        gaPanelConfig.AppID = appData!.app_id;
        gaPanelConfig.AppSlug = appData!.slug;
        gaPanelConfig.DeveloperID = appData!.developer_id;
        gaPanelConfig.AppName = appData!.app_name;
        gaPanelConfig.BtnText = appData!.status;
        captureGAEvent("sras_permission_close_button_click", "sras_permission_close_button_click");

        setPopupOpen(false);
    };
    const handleInstallClick = () => {
        setPopupOpen(true);
    };
    const sendGAEvent = (event: string) => {
        clearEvents();
        gaPanelConfig.AppID = appData!.app_id;
        gaPanelConfig.AppSlug = appData!.slug;
        gaPanelConfig.DeveloperID = appData!.developer_id;
        gaPanelConfig.AppName = appData!.app_name;
        gaPanelConfig.BtnText = appData!.status;
        captureGAEvent(event, event);
    };
    const handleLogin = () => {
        localStorage.setItem('slug', appData!.slug);
        const slugData = localStorage.getItem('slug');

        const nextRedirectUrlFormatted = nextRedirectUrl?.replace(/\/$/, ''); // Remove trailing slash if any
        const slugDataFormatted = slugData?.replace(/^\//, ''); // Remove leading slash if any

        const combinedUrl = `${nextRedirectUrlFormatted}/${slugDataFormatted}`; // Combine URLs without encoding
        const safeCombinedUrl = combinedUrl; // No need to encode the combined URL

        window.location.href = `${authUrl}/login?nextRedirectUrl=${safeCombinedUrl}`;
        // Handle login logic or redirect to login page

    }

    const installApp2 = async (app_id) => {
        const apiUrl = POSTINSTALLAPP2();

        const requestData = {
            app_id: app_id,
        };

        try {
            console.log("install click")

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.token}`,
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                console.log("install click error")
                throw new Error('Network response was not ok');
            }

            const jsonData = await response.json();
            console.log("install click response")
            // Handle the response data as needed
            if (jsonData.data && jsonData.data.redirect_url) {
                const redirectUrl = jsonData.data.redirect_url;
                setIsInstalled(true);
                console.log("Install Url=> " + redirectUrl)
                window.open(redirectUrl, '_blank');
            } else {
                // setOpen(true);
                console.error('URL not found in the response data');
                toast.error("Something went wrong", {

                });
            }
        } catch (error) {
            console.error('Error installing app:', error);
            toast.error("Something went wrong", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };


    const installApp = async (slug, appId) => {
        const apiUrl = POSTINSTALLAPP(); // Call the function to get the URL
        const requestData = {
            slug: slug,
            app_id: appId,
        };

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.token}`
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            console.log("click outside app")
            const responseData = await response.json();
            console.log("Url check " + responseData)
            // Handle the response data as needed
            if (responseData.data && responseData.data.url) {
                const redirectUrl = responseData.data.url;

                try {
                    setIsInstalled(true);
                    console.log("Url redirect: " + redirectUrl);

                    // Open the link in a new window
                    window.open(redirectUrl, '_blank');
                } catch (error) {
                    console.error("Error installing outside app:", error);
                }
            }

            else {
                // setOpen(true);
                console.error('URL not found in the response data');
                toast.error("Something went wrong", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }

        } catch (error) {
            console.error('Error making API request:', error);
            toast.error("Something went wrong", {
                position: toast.POSITION.TOP_RIGHT,
            });
            // Handle errors
        }
    };


    const handleInstall = async () => {
        localStorage.setItem("permission", "false");
        gaPanelConfig.AppID = appData.app_id;
        gaPanelConfig.DeveloperID = appData.developer_id;
        gaPanelConfig.AppName = appData.app_name;

        console.log("print ga logs");
        if (!auth.token) {
            clearEvents();
            gaPanelConfig.AppID = appData!.app_id;
            gaPanelConfig.AppSlug = appData!.slug;
            gaPanelConfig.DeveloperID = appData!.developer_id;
            gaPanelConfig.AppName = appData!.app_name;
            gaPanelConfig.BtnText = "Log in to install";
            sendGAEvent('sras_app_install_button_click');
            console.log("send ga events")
            // If not logged in, handle login action
            handleLogin();
            return;
        }

        try {
            console.log("AppStatus=> " + appData.status)


            if (appData.status === 'Installed') {
                clearEvents();
                gaPanelConfig.AppID = appData!.app_id;
                gaPanelConfig.AppSlug = appData!.slug;
                gaPanelConfig.DeveloperID = appData!.developer_id;
                gaPanelConfig.AppName = appData!.app_name;
                gaPanelConfig.BtnText = appData!.status;
                sendGAEvent('sras_app_install_button_click');
                if (appData.app_type === 3) {
                    clearEvents();
                    gaPanelConfig.AppID = appData!.app_id;
                    gaPanelConfig.AppSlug = appData!.slug;
                    gaPanelConfig.DeveloperID = appData!.developer_id;
                    gaPanelConfig.AppName = appData!.app_name;
                    gaPanelConfig.BtnText = appData!.status;
                    sendGAEvent('sras_permission_install_button_click');
                    //open Install2 Api
                    setInstallLoading(true);
                    await installApp2(appData.app_id);

                }
                if (appData.app_type !== 3) {
                    clearEvents();

                    gaPanelConfig.AppID = appData!.app_id;
                    gaPanelConfig.AppSlug = appData!.slug;
                    gaPanelConfig.DeveloperID = appData!.developer_id;
                    gaPanelConfig.AppName = appData!.app_name;
                    gaPanelConfig.BtnText = "OPEN";
                    sendGAEvent('sras_app_install_button_click');


                    //open Install Api
                    setInstallLoading(true);
                    await installApp(appData.slug, appData.app_id);



                }


            }


            else if (appData.status === 'Not Permitted') {
                clearEvents();
                gaPanelConfig.BtnText = "Not Permitted";
                sendGAEvent('sras_app_install_button_click');
                // setErrormsg 'Install is not supported' disable click
                setInstallErrorMessage('Install is not supported');
            }
            else {

                if (appData.app_type === 3) {
                    console.log("click to intall app")
                    localStorage.setItem("permission", "true");
                    //open pop up
                    // Approve button -> call permission approve api
                    handleInstallClick();
                }

                else {
                    setInstallLoading(true);
                    await installApp(appData.slug, appData.app_id);
                }

            }

            // Update state to indicate that the app is installed
            // You may also want to update the appData.status in your Redux store
            // dispatch(updateAppStatus(appData.id, 'installed'));
        } catch (error) {
            toast.error("somthing went wromg")
            console.error('Error installing app:', error);
        } finally {
            // Set isInstallLoading back to false once the installation is complete or an error occurs
            setInstallLoading(false);
        }
    };
    ///capture events    
    return (
        <>
            <div>
                 <div style={{ gap: '30px' }}
                    className={isTabletView ? "flex flex flex-col  justify-center" : "flex flex flex-col md:flex-row justify-center"}>

                    <div className="lg-w-30p">

                        <div
                            className={isTabletView ? "flex flex-col justify-between" : "flex flex-col justify-between card"}
                            style={
                                isTabletView ? {
                                    padding: '20px',
                                    border: '1px solid #D3D3D3',
                                    borderRadius: '20px',
                                    opacity: 1,
                                    backdropFilter: 'blur(14px)',
                                    WebkitBackdropFilter: 'blur(14px)',
                                    backgroundSize: '210% 170%',
                                    backgroundPosition: 'center',
                                    width: "100%",
                                    backgroundImage: `url(${cardBackground})`,
                                } : {
                                    // border: '1px solid #D3D3D3',
                                    borderRadius: '20px',
                                    opacity: 1,
                                    backdropFilter: 'blur(14px)',
                                    WebkitBackdropFilter: 'blur(14px)',
                                    backgroundSize: '210% 170%',
                                    backgroundPosition: 'center',
                                    width: "100%",
                                    minHeight: "452px",
                                    backgroundImage: `url(${cardBackground})`,


                                }}

                        >
                            {appData.status === "Installed" && (
                                <div className="relative">
                                    <img
                                        src={install2}
                                        alt="Image"
                                        className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 z-10 md:mr-5 md:mt-5 lg:mr-0 custom-position"
                                        style={{ width: "80px", height: "auto" }}
                                    />
                                </div>




                            )}

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {isTabletView ?
                                    (
                                        <div className="row" style={{ columnGap: '10px' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                <div className="rounded-sm overflow-hidden relative group-hover:scale-[1.025] w-appIcon--sm" style={{ background: '#FFFFFF', border: '1px solid #E2E2E2', borderRadius: '14px', opacity: 1, height: '100px', width: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: 'none' }}>
                                                    <img style={{ maxWidth: '100%', maxHeight: '100%', height: '80px', width: '80px' }} alt="" srcSet={appData.app_icon} className="block relative shrink-0 w-appIcon--sm" src={appData.app_icon} />
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ maxWidth: '350px' }}>
                                                    <p style={{ fontFamily: "sfprobold", fontSize: "30px", color: '#131340' }}>{appData.app_name}</p>
                                                </div>
                                                <div>
                                                    <p className="" style={{ fontFamily: 'sfproregular', fontSize: '18px', paddingBottom: '40px', color: '#131340' }}>
                                                        {
                                                            appData.slug === 'rto_score' ? '' :
                                                                appData.slug === 'delivery_boost' ? 'Trial Available' :
                                                                    appData.slug === 'openapp' ? 'Trial Available' :
                                                                        appData.slug === 'capital' ? '' :
                                                                            appData.slug === 'squadstack' ? 'Trial Available' :
                                                                                appData.slug === 'brand_boost' ? '' :
                                                                                    appData.slug === 'amplify' ? '' :
                                                                                        appData.slug === 'engage_plus' ? '' :
                                                                                            'Free plan available'
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className="row" style={{}}>
                                                <div >
                                                    <div
                                                        className="rounded-sm overflow-hidden relative group-hover:scale-[1.025] w-appIcon--sm"
                                                        style={{
                                                            background: '#FFFFFF',
                                                            border: '1px solid #E2E2E2',
                                                            borderRadius: '14px',
                                                            opacity: 1,
                                                            // margin: '10px',
                                                            height: '100px',
                                                            width: '100px',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            // padding: '10px', // Add inner padding
                                                            boxShadow: 'none'
                                                        }}
                                                    >
                                                        <img
                                                            style={{ maxWidth: '100%', maxHeight: '100%', height: '80px', width: '80px' }}
                                                            alt=""
                                                            srcSet={appData.app_icon}
                                                            className="block relative shrink-0 w-appIcon--sm"
                                                            src={appData.app_icon}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ maxWidth: '350px' }}>
                                                <p style={{ fontFamily: "sfprobold", fontSize: '30px', color: '#131340', wordWrap: 'break-word' }}>{appData.app_name}</p>

                                            </div>
                                            <div >

                                                <p className="" style={{ fontFamily: 'sfproregular', fontSize: '18px', paddingBottom: appData.app_name.length > 17 ? '20px' : '40px', color: '#131340' }}>
                                                    {
                                                        appData.slug === 'rto_score' ? '' :
                                                            appData.slug === 'delivery_boost' ? 'Trial Available' :
                                                                appData.slug === 'openapp' ? 'Trial Available' :
                                                                    appData.slug === 'squadstack' ? 'Trial Available' :
                                                                        appData.slug === 'capital' ? '' :

                                                                            appData.slug === 'brand_boost' ? '' :
                                                                                appData.slug === 'amplify' ? '' :
                                                                                    appData.slug === 'engage_plus' ? '' :

                                                                                        'Free plan available'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                <div >
                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '25px' }}>
                                        <div style={{ flex: '1', }}>
                                            <h3 style={{ fontFamily: 'sfproregular', fontSize: '15px', color: '#727272', marginBottom: '2px' }}>Rating({(appData.overall_rating ?? 4.2).toFixed(1)}) </h3>
                                            <div style={{ display: 'flex', justifyContent: 'flexStart', }}>
                                                {[...Array(5)].map((_, index) => (
                                                    <img
                                                        key={index}
                                                        src={index < Math.floor(appData.overall_rating ?? 0) ? star : star_greyed}
                                                        alt="Star Icon"
                                                        style={{ height: '13px', width: '14px', marginRight: '2px' }}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ flex: '0.9', paddingLeft: "16px" }}>
                                            <h3 style={{ fontSize: '15px', color: '#727272', height: '15px', marginBottom: '5px', fontFamily: 'sfproregular' }}>Reviews </h3>
                                            <p style={{ fontFamily: "sfprobold", fontSize: "15px", color: '#727272' }}>{appData.rating_count}</p>
                                        </div>
                                        <div style={{ flex: '1', }}>
                                            <h3 style={{ fontFamily: 'sfproregular', fontSize: '15px', color: '#727272', marginBottom: '5px', height: '15px' }}>Developer</h3>
                                            <Tooltip title={appData?.developer_details?.partner_name}>
                                                <p
                                                    style={{
                                                        fontFamily: "sfprobold",
                                                        fontSize: "15px",
                                                        color: '#727272',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '100%',
                                                    }}
                                                    title={appData?.developer_details?.partner_name ?? "Shiprocket"}
                                                >
                                                    {appData?.developer_details?.partner_name ? (
                                                        appData.developer_details.partner_name.length > 12 ?
                                                            `${appData.developer_details.partner_name.substring(0, 12)}...` :
                                                            appData.developer_details.partner_name
                                                    ) : (
                                                        "Shiprocket"
                                                    )}
                                                </p>
                                            </Tooltip>

                                        </div>
                                    </div>
                                </div>
                                <div >
                                    <Tooltip title={appData.status === 'Not Permitted' ? "You are not permitted to Install this app " : ""}>
                                        <button
                                            style={appData.status === 'Not Permitted' ? { color: "white", background: "grey" } : {}}
                                            className="install-button"
                                            onClick={handleInstall}
                                            disabled={isInstallLoading || appData.status === 'Not Permitted'}
                                        >
                                            {auth.token !== null ? (
                                                isInstallLoading ? (
                                                    <CircularProgress color="inherit" size={40} />
                                                ) : (appData.status === 'Installed' ? 'Open' : (isInstalled ? 'Open' : 'Install')

                                                )
                                            ) : (
                                                'Login to Install'
                                            )}
                                        </button>
                                    </Tooltip>

                                    {errorInstallMessage && <p style={{ color: 'red', marginTop: ' ' }}>{errorInstallMessage}</p>}


                                </div>
                                <InstallPopup open={isPopupOpen} onClose={handlePopupClose} appData={appData} viewType={isTabletView ? 'tab' : 'web'} />
                            </div>

                        </div>
                    </div>

                    <div className={isTabletView ? "container" : "w-full md:w-2/3 lg:w-2/3"}>
                        <div
                            className=" "
                            style={{
                                zIndex: '0'
                            }}
                        >{appData && appData.banners && (<ImageCarousel banners={appData.banners} height={isTabletView ? "175px" : "452px"} />)}

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

CardBanner.propTypes = {
    appData: PropTypes.shape({
        status: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        app_id: PropTypes.string.isRequired,
        banners: PropTypes.string,
        app_icon: PropTypes.string,
        app_name: PropTypes.string,
        app_type: PropTypes.string,
        overall_rating: PropTypes.string,
        rating_count: PropTypes.string,
        height: PropTypes.string,
        developer_id: PropTypes.string.isRequired,
        developer_details: PropTypes.string.isRequired,
        // Add other required properties here
    }).isRequired,
};

export default CardBanner;
